module.exports = __webpack_public_path__ + "img/narzady-wewn.4db794e1.jpg";